import { render, staticRenderFns } from "./VDrugsSummary.vue?vue&type=template&id=2ba10bcc&scoped=true&"
import script from "./VDrugsSummary.vue?vue&type=script&lang=js&"
export * from "./VDrugsSummary.vue?vue&type=script&lang=js&"
import style0 from "./VDrugsSummary.vue?vue&type=style&index=0&id=2ba10bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba10bcc",
  null
  
)

export default component.exports